import { useGlobalStateStore } from "@/store/GlobalState"
import { isDevEnv } from "@/utils/enviroment"

class HardCodedUtil {
	private readonly adminUsersMap = {
		MAYARA_KIMURA: 71,
		ANA_CAROLINE: 2,
		TONIM_LETALK: 5,
		BRUNO: 8,
		FINANCEIRO: 11,
		GABI: 12,
		GUSTAVO_BASTOS: 17,
		JOHN: 20,
		LAURA: 23,
		LETICIA: 24,
		PEDRO: 30,
		RAYAN: 31,
		RENATO: 33,
		SAMUEL: 36,
		VITORIA: 42,
		ANA: 43,
		LARA: 46,
		MARIANA_RODRIGUES: 47,
		DAVID: 50,
		BRIAN: 51,
		LHUANA: 52,
		RENATO_CALABREZI: 53,
		SAMUEL_AMPARO: 54,
		JESSICA_MARIANO: 59,
		GUI_VILELA: 1,
		RAFAEL: 32,
		JU: 21,
		INGRID_NAYARA: 56,
		SABRINA_LOPES: 61,
		MATHEUS_DEV: 60,
		MOTA: 14,
		YASMIN_MELGACO: 63,
		PEDRO_LUCENA: 65,
		ISRAEL_CRUZ: 66,
		MARIA_CLARA: 69,
		TON: 64,
		ADMINISTRATIVO: 58,
		THAUANA: 72,
		THAYNA: 38,
		THAINAN: 37,
		MATHEUS: 28,
		GEISA: 73,
		GABRIEL_AMARAL: 74,
		WALLACE: 76,
		SUELYN: 78,
		KARINA: 79,
		POLIANA: 75,
		ASSINATURAS: 80,
		MARIA_SUYANY: 82,
		LEONARDO: 81,
		JOAO_PEDRO: 84,
		LAVINIA_CHARRUA: 85,
		IASMIN_TORRES: 86,
		GABRIELA_MEDEIROS: 87,
		IGOR_BEZERRA: 88,
		MIGUEL_COELHO: 89
	}

	private readonly csTeam = [
		this.adminUsersMap.RENATO,
		this.adminUsersMap.VITORIA,
		this.adminUsersMap.DAVID,
		this.adminUsersMap.GUSTAVO_BASTOS,
		this.adminUsersMap.SABRINA_LOPES,
		this.adminUsersMap.MAYARA_KIMURA,
		this.adminUsersMap.THAUANA,
		this.adminUsersMap.GABRIEL_AMARAL,
		this.adminUsersMap.WALLACE,
		this.adminUsersMap.POLIANA,
		this.adminUsersMap.IASMIN_TORRES,
		this.adminUsersMap.LEONARDO,
		this.adminUsersMap.GABRIELA_MEDEIROS,
		this.adminUsersMap.IGOR_BEZERRA,
		this.adminUsersMap.MIGUEL_COELHO
	]

	private readonly financialTeam = [
		this.adminUsersMap.FINANCEIRO
	]

	private readonly salesTeam = [
	]

	private readonly supportTeam = [
		this.adminUsersMap.LAURA,
		this.adminUsersMap.YASMIN_MELGACO,
		this.adminUsersMap.MARIA_CLARA,
		this.adminUsersMap.GEISA,
		this.adminUsersMap.SUELYN,
		this.adminUsersMap.KARINA,
		this.adminUsersMap.LEONARDO,
		this.adminUsersMap.MARIA_SUYANY,
		this.adminUsersMap.LAVINIA_CHARRUA
	]

	private readonly dataAutomationsTeam = [
		this.adminUsersMap.ANA_CAROLINE,
		this.adminUsersMap.THAINAN
	]

	private readonly marketingTeam = [
		this.adminUsersMap.JESSICA_MARIANO,
		this.adminUsersMap.THAINAN,
		this.adminUsersMap.MATHEUS

	]

	private readonly productTeam = [
		this.adminUsersMap.SAMUEL,
		this.adminUsersMap.JOAO_PEDRO
	]

	private readonly technologyTeam= [
		this.adminUsersMap.MOTA,
		this.adminUsersMap.TONIM_LETALK,
		this.adminUsersMap.BRIAN,
		this.adminUsersMap.JOHN,
		this.adminUsersMap.PEDRO_LUCENA,
		this.adminUsersMap.ISRAEL_CRUZ,
		this.adminUsersMap.MATHEUS_DEV,
		this.adminUsersMap.TON,
		this.adminUsersMap.SAMUEL
	]

	private readonly signaturesTeam = [
		this.adminUsersMap.GABI,
		this.adminUsersMap.ASSINATURAS,
		this.adminUsersMap.FINANCEIRO,
		this.adminUsersMap.JOAO_PEDRO
	]

	private readonly boardTeam = [
		this.adminUsersMap.GUI_VILELA
	]

	private readonly administrativeTeam = [
		this.adminUsersMap.ADMINISTRATIVO
	]

	private readonly leadershipTeam = [
		this.adminUsersMap.RENATO_CALABREZI,
		this.adminUsersMap.ANA,
		this.adminUsersMap.LETICIA,
		this.adminUsersMap.RAYAN,
		this.adminUsersMap.THAYNA
	]

	private readonly onboardingTeam = [
		this.adminUsersMap.SABRINA_LOPES,
		this.adminUsersMap.LEONARDO,
		this.adminUsersMap.GABRIEL_AMARAL,
		this.adminUsersMap.IASMIN_TORRES,
		this.adminUsersMap.IGOR_BEZERRA,
		this.adminUsersMap.MIGUEL_COELHO
	]

	private get adminId () {
		const useGlobalState = useGlobalStateStore()

		return useGlobalState.userData.id as number
	}

	canDeleteAccountAndInstanceOnCascade (): boolean {
		return [
			...this.productTeam,
			...this.technologyTeam,
			this.adminUsersMap.LETICIA
		].includes(this.adminId) || isDevEnv
	}

	canClearInboxAttendances (): boolean {
		return [
			...this.technologyTeam,
			...this.productTeam,
			...this.supportTeam,
			...this.onboardingTeam
		].includes(this.adminId)
	}

	canChangeInstanceOwner (): boolean {
		return [
			...this.productTeam,
			...this.technologyTeam,
			...this.signaturesTeam,
			...this.dataAutomationsTeam
		].includes(this.adminId) || isDevEnv
	}

	canBlockAccountSubscription (): boolean {
		return [
			...this.productTeam,
			...this.financialTeam,
			...this.dataAutomationsTeam,
			...this.signaturesTeam
		].includes(this.adminId) || isDevEnv
	}

	canChangeModuleStatus (adminUserId: number): boolean {
		return [
			...this.signaturesTeam,
			...this.supportTeam,
			...this.leadershipTeam,
			...this.technologyTeam,
			...this.productTeam,
			...this.boardTeam,
			...this.csTeam
		].includes(adminUserId)
	}

	canChangeUserMfa (): boolean {
		return [
			...this.technologyTeam,
			...this.productTeam,
			...this.leadershipTeam,
			...this.supportTeam
		].includes(this.adminId)
	}

	canCreateOrEditPlanAndAddonsInfo (): boolean {
		return [
			...this.productTeam,
			...this.technologyTeam,
			...this.dataAutomationsTeam,
			...this.boardTeam
		].includes(this.adminId) || isDevEnv
	}

	canEditPhoneNumberOfInstanceResponsible (): boolean {
		return [
			...this.signaturesTeam
		].includes(this.adminId) || isDevEnv
	}

	canUseBulkSubscriptionsActions (): boolean {
		return [
			...this.signaturesTeam,
			...this.technologyTeam,
			...this.dataAutomationsTeam
		].includes(this.adminId) || isDevEnv
	}

	canMigrateChannelFromWebtoWaba (): boolean {
		return [
			...this.technologyTeam,
			...this.csTeam
		].includes(this.adminId) || isDevEnv
	}
}

export default new HardCodedUtil()
